// Core
import React, { Component } from 'react';

// Styles
import './styles.css';

// Components
import Card from '../../../../components/Card';
import ExpandableContent from '../../../../components/ExpandableContent';
import HtmlWrapper from '../../../../components/HtmlWrapper';

// Services
import { __, STR_KEY } from '../../../../services/Translate';
import Hosts from '../../../../components/Hosts';

export default class EventDescription extends Component {

    render() {
        const eventDescription = (this.props.description || '').replace(/(<([^>]+)>)/ig, '');
        const noOfEventHosts = this.props.hosts.length;

        if (!eventDescription && !noOfEventHosts) return null;

        const heading = () => {
            if (!eventDescription) {
                return null;
            }
            return __(STR_KEY.MISC_ABOUT_EVENT);
        }

        const renderDescription = eventDescription ? (<HtmlWrapper {...{ id: 'descriptionBox', className: 'eventDescriptionText', html: this.props.description}} />) : null;
        return (
            <Card className="eventDescription">
                <h2 className="eventDescriptionTitle">{heading()}</h2>
                <ExpandableContent>
                    { renderDescription }
                    <Hosts hosts={this.props.hosts} />
                </ExpandableContent>
            </Card>
        );
    }
}
